export default __webpack_public_path__ + "static/media/triiboLojaAndroid.ae31c4f5.png";